import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import EffectUtility from '../../utilities/EffectUtility';
import ValidateAccountModel from './models/login/ValidateAccountModel';
import UserAuthenticatedModel from './models/login/UserAuthenticatedModel';
import TokenModel from './models/login/TokenModel';

export default class ShowsEffect {
    public static async requestValidateAccount(params?: any): Promise<ValidateAccountModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.validateAccount;
        return EffectUtility.getToModel<ValidateAccountModel>(ValidateAccountModel, endpoint, params);
    }

    public static async requestAuthenticate(params?: any, headers?: any): Promise<UserAuthenticatedModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.signIn;
        return EffectUtility.getToModel<UserAuthenticatedModel>(UserAuthenticatedModel, endpoint, params, { headers });
    }

    public static async requestToken(params?: any): Promise<TokenModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.token;
        return EffectUtility.postToModel<TokenModel>(TokenModel, endpoint, params);
    }
}
